import { Toast } from 'antd-mobile';
import {
  gameKingInfo,
  gameKingPrizePool,
  gameKingGame,
  gameKingGameTip,
  gameKingGameRecord,
  gameKingBraveInfo,
  gameKingBraveList,
  gameKingAttack,
  gameKingDragonRewards,
  gameKingDragonTip,
  gameKingWarriorTip,
  gameKingKingRewards,
  gameKingFloat,
} from '@/services/activity';

export default {
  namespace: 'activityGameKing',
  state: {
    title: '',
    titleUrl: '',
    rules: '',
    gameChallengeRules: '',
    bravelyFightDragonRules: '',
    activityId: '',
    countDown: 0,
    status: 0,
    showRulesTip: 0,
    coinAmount: '',
    pastTime: 0,
    topTimeDurationMillis: 0,
    roundCoinAmount: '',
    gameScore: '',
    gameUserInfo: {},
    gameTopUser: {},
    gameRankInfo: {
      pageNum: 1,
      pageSize: 20,
    },
    isGameMore: false,
    gameRankList: [],
    gameRound: '',
    showConfirmTips: 1,
    braveRound: '',
    dragonInfo: {
      maxHP: 0,
      currentHP: 0,
    },
    topUser: {},
    attackBtns: [],
    rewardCoins: {},
    availableEnergy: '',
    currentRoundEnergy: '',
    lastId: '',
    ranks: [],
    selfInfo: {},
    braveCountDown: 0,
    kingRewardsInfo: {},
    braveRewardsInfo: {},
  },
  reducers: {
    updateInfo(state, { payload }) {
      return {
        ...state,
        title: payload.title || '',
        titleUrl: payload.titleUrl || '',
        rules: payload.rules || '',
        gameChallengeRules: payload.gameChallengeRules || '',
        bravelyFightDragonRules: payload.bravelyFightDragonRules || '',
        countDown: payload.countDown || 0,
        status: payload.status || 0,
        showRulesTip: payload.showRules || 0,
      };
    },
    updatePoolInfo(state, { payload }) {
      return {
        ...state,
        coinAmount: payload.coinAmount || 0,
      };
    },
    updateGameInfo(state, { payload }) {
      return {
        ...state,
        pastTime: payload.pastTime || 0,
        topTimeDurationMillis: payload.topTimeDurationMillis || 0,
        roundCoinAmount: payload.roundCoinAmount || 0,
        gameTopUser: payload.topUser || {},
        gameUserInfo: payload.userInfo || {},
        gameRound: payload.gameRound || 1,
      };
    },
    updateGameList(state, { payload }) {
      let newList = payload.force ? [] : [...state.gameRankList];
      let isMore = false;
      if (payload.records && payload.records.length) {
        newList = [...newList, ...payload.records];
        isMore = payload.records.length >= state.gameRankInfo.pageSize;
      }
      return {
        ...state,
        gameRankList: newList,
        gameRankInfo: {
          pageNum: payload.pageNum || 1,
          pageSize: state.gameRankInfo.pageSize,
        },
        isGameMore: isMore,
      };
    },
    updateBraveInfo(state, { payload }) {
      const { maxHP = 0, currentHP = 0 } = payload.dragonInfo || {};
      return {
        ...state,
        showConfirmTips: payload.showConfirmTips || 0,
        braveRound: payload.braveRound || 1,
        dragonInfo: {
          maxHP: maxHP,
          currentHP: maxHP - currentHP >= 0 ? maxHP - currentHP : 0,
        },
        topUser: payload.topUser || {},
        attackBtns: payload.attackBtns || [],
        rewardCoins: payload.rewardCoins || {},
        availableEnergy: payload.availableEnergy || 0,
        currentRoundEnergy: payload.currentRoundEnergy || 0,
        braveCountDown: payload.countDown || 0,
      };
    },
    updateAttackInfo(state, { payload }) {
      const { maxHP = 0, currentHP = 0 } = payload;
      return {
        ...state,
        dragonInfo: {
          maxHP: maxHP,
          currentHP: maxHP - currentHP >= 0 ? maxHP - currentHP : 0,
        },
        availableEnergy: payload.availableEnergy || 0,
        currentRoundEnergy: payload.currentRoundEnergy || 0,
      };
    },
    updateBraveList(state, { payload }) {
      let list = payload.force ? [] : [...state.ranks];
      let selfInfo = {};
      let lastId = '';
      if (payload.ranks && payload.ranks.length) {
        list = [...list, ...payload.ranks];
        lastId = payload.ranks[payload.ranks.length - 1].userId;
      }
      if (payload.selfInfo && payload.selfInfo.userId) {
        selfInfo = payload.selfInfo;
      }
      return {
        ...state,
        selfInfo: selfInfo,
        ranks: list,
        lastId,
      };
    },
    updateKingRewards(state, { payload }) {
      return {
        ...state,
        kingRewardsInfo: { ...payload },
      };
    },
    updateBraveRewards(state, { payload }) {
      return {
        ...state,
        braveRewardsInfo: { ...payload },
      };
    },
  },
  effects: {
    *getInfo({ payload }, { call, put }) {
      const { error, data } = yield call(gameKingInfo, payload);
      if (error || !data) {
        yield put({
          type: 'updateInfo',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateInfo',
        payload: data,
      });
      return true;
    },
    *getPoolInfo({ payload }, { call, put }) {
      const { error, data } = yield call(gameKingPrizePool, payload);
      if (error || !data) {
        yield put({
          type: 'updatePoolInfo',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updatePoolInfo',
        payload: data,
      });
      return {
        success: true,
        data,
      };
    },
    *getGameInfo({ payload }, { call, put }) {
      const { error, data } = yield call(gameKingGame, payload);
      if (error || !data) {
        yield put({
          type: 'updateGameInfo',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateGameInfo',
        payload: data,
      });
      return {
        success: true,
        data,
      };
    },
    *getGameTips({ payload }, { call, put }) {
      const { error, data } = yield call(gameKingGameTip, payload);
      if (error || !data) {
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      return {
        success: true,
        data,
      };
    },
    *getGameRecord({ payload }, { call, put, select }) {
      const { gameRankInfo } = yield select(state => state.activityGameKing);
      const { pageNum = 1, pageSize = 20 } = gameRankInfo;
      const { error, data } = yield call(gameKingGameRecord, {
        ...payload,
        pageNum: payload.force ? 1 : pageNum,
        pageSize: pageSize,
        force: undefined,
      });
      if (error || !data) {
        yield put({
          type: 'updateGameList',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateGameList',
        payload: { ...data, pageNum: payload.force ? 2 : pageNum + 1, pageSize, force: payload.force },
      });
      return true;
    },
    *getGameBraveInfo({ payload }, { call, put }) {
      const { error, data } = yield call(gameKingBraveInfo, payload);
      if (error || !data) {
        yield put({
          type: 'updateBraveInfo',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateBraveInfo',
        payload: data,
      });
      return {
        success: true,
        data,
      };
    },
    *getBraveList({ payload }, { call, put, select }) {
      const { lastId } = yield select(state => state.activityGameKing);
      const { error, data } = yield call(gameKingBraveList, { ...payload, lastId: payload.force ? '' : lastId, force: undefined });
      if (error || !data) {
        yield put({
          type: 'updateBraveList',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateBraveList',
        payload: { ...data, force: payload.force },
      });
      return true;
    },
    *gameAttack({ payload }, { call, put }) {
      const { error, data } = yield call(gameKingAttack, payload);
      if (error || !data) {
        yield put({
          type: 'updateAttackInfo',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateAttackInfo',
        payload: data,
      });
      return {
        success: true,
        data: data,
      };
    },
    *getDragonRewards({ payload }, { call, put }) {
      const { error, data } = yield call(gameKingDragonRewards, payload);
      if (error || !data) {
        yield put({
          type: 'updateBraveRewards',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateBraveRewards',
        payload: data,
      });
      return true;
    },
    *getDragonTip({ payload }, { call }) {
      const { error, data } = yield call(gameKingDragonTip, payload);
      if (error || !data) {
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      return {
        success: true,
        data: data,
      };
    },
    *gameKingKingRewards({ payload }, { call, put }) {
      const { error, data } = yield call(gameKingKingRewards, payload);
      if (error || !data) {
        yield put({
          type: 'updateKingRewards',
          payload: data,
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateKingRewards',
        payload: data,
      });
      return true;
    },
    *gameKingWarriorTip({ payload }, { call, put }) {
      const { error, data } = yield call(gameKingWarriorTip, payload);
      if (error || !data) {
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return {
          success: false,
          data: {},
        };
      }
      return {
        success: true,
        data: data,
      };
    },
    *getFloatList({ payload }, { call }) {
      const { error, data } = yield call(gameKingFloat, payload);
      if (error) {
        return {
          error,
          success: false,
        };
      }
      if (data) {
        return {
          success: true,
          data: data,
        };
      } else {
        return false;
      }
    },
  },
};
